import React, { useState } from 'react'
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';

import "./Header.css"
import logo from "../Assets/logo.png"
import tele from "../Assets/telegram.png"
import twi from "../Assets/twitter.png"
import { AiOutlineMenu } from 'react-icons/ai'
import { RxCross2 } from 'react-icons/rx'

export default function Header() {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    return (
        <header className='main_headr'>
            <Navbar collapseOnSelect expand="lg" className="main_nav_bar">
                <Container>
                    <Navbar.Brand href="#home" className='main_logo'><img src={logo} alt="" /></Navbar.Brand>
                    <span className='d-block d-lg-none' onClick={() => setShow(!show)} >
                        {

                            show ? <><RxCross2 className='text-white fs-1' /> </> : <><AiOutlineMenu className='text-white fs-1' /></>
                        }


                    </span>
                    {/* <Navbar.Toggle aria-controls="responsive-navbar-nav" /> */}
                    <Navbar.Collapse id="responsive-navbar-nav" className={show ? "show" : ""}>
                        <Nav className="m-auto">
                            <Nav.Link href="#ABOUT" onClick={handleClose} className='gr_clr'>ABOUT</Nav.Link>
                           
                           
                            <Nav.Link href="#Roadmap" onClick={handleClose} className='text-white'>Roadmap</Nav.Link>
                            <Nav.Link href="#Tokenomics" onClick={handleClose} className='text-white'>Tokenomics</Nav.Link>
                            <Nav.Link href="#Features" onClick={handleClose} className='text-white'>Features</Nav.Link>
                            <Nav.Link href="#WHITEPAPER" onClick={handleClose} className='text-white'>WHITEPAPER</Nav.Link>
                            <Nav.Link href="#HowToBuy" onClick={handleClose} className='text-white'>How To Buy</Nav.Link>
                            <Nav.Link href="#Faq" onClick={handleClose} className='text-white'>Faq</Nav.Link>

                        </Nav>
                        <Nav className='d-flex gap-2 align-items-center'>
                            <div className='d-flex gap-3'>
                            <a href="https://t.me/theRabbitsnetwork" target="_blank"    >  <img src={tele} className='head_icon' alt="" /></a>
                            <a href="https://x.com/RabbitsNETWORK" target="_blank"    >    <img src={twi} className='head_icon' alt="" /></a>
                            </div>
                            <button className='head_btn nor_font'>BUY NOW</button>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </header>
    )
}
